import { useMemo } from 'react';
import { useControls, folder } from 'leva';
import { isRoad, isRiver, isObject, getHeight } from './Terrain';
import { Tree } from './Tree';

const MAP_SIZE = 340;
const MAP_RADIUS = 170;

const seededRandom = (s: number) => {
    const x = Math.sin(s) * 10000;
    return x - Math.floor(x);
};

export const Forest = () => {
    const { treeCount } = useControls('Trees', {
        'General': folder({
            treeCount: { value: 120, min: 0, max: 400, step: 1, label: 'Tree Count' }
        })
    });

    const trees = useMemo(() => {
        const list: Array<{ position: [number, number, number]; seed: number }> = [];
        let attempts = 0;
        let seed = 1337;
        const maxAttempts = Math.max(100, treeCount * 30);

        while (list.length < treeCount && attempts < maxAttempts) {
            attempts += 1;
            const rx = seededRandom(seed++);
            const rz = seededRandom(seed++);

            const x = (rx - 0.5) * MAP_SIZE;
            const z = (rz - 0.5) * MAP_SIZE;

            if (Math.sqrt(x * x + z * z) > MAP_RADIUS) continue;
            if (isRoad(x, z) || isRiver(x, z) || isObject(x, z)) continue;

            const y = getHeight(x, z);
            // Push trees slightly into the ground to avoid floating on slopes
            list.push({ position: [x, y - 0.3, z], seed });
        }

        return list;
    }, [treeCount]);

    return (
        <group>
            {trees.map((tree, index) => (
                <Tree key={`${tree.seed}-${index}`} position={tree.position} seed={tree.seed} />
            ))}
        </group>
    );
};
